import { Component, Input, Output } from '@angular/core';
import { OnDestroy, AfterContentInit } from '@angular/core';
import { EventEmitter, ContentChildren, QueryList } from '@angular/core';
import { Subscription } from 'rxjs';

import { TdStepComponent } from './step.component';

export interface IStepChangeEvent {
  newStep: TdStepComponent;
  prevStep: TdStepComponent;
}
export type StepMode = number;
export let StepMode: any = {};
StepMode.Vertical =  /** @type {?} */(( <any>'vertical'));
StepMode.Horizontal =  /** @type {?} */(( <any>'horizontal'));
StepMode[StepMode.Vertical] = "Vertical";
StepMode[StepMode.Horizontal] = "Horizontal";

export class TdStepsComponent implements OnDestroy, AfterContentInit {
private _subcriptions: Subscription[];
private _mode: StepMode = StepMode.Vertical;
private _steps: QueryList<TdStepComponent>;
/**
 * @param {?} steps
 * @return {?}
 */
set stepsContent(steps: QueryList<TdStepComponent>) {
    if (steps) {
      this._steps = steps;
      this._registerSteps();
    }
  }
/**
 * @return {?}
 */
get steps(): TdStepComponent[] {
    return this._steps.toArray();
  }
  prevStep: TdStepComponent;
/**
 * mode?: StepMode or ["vertical" | "horizontal"]
 * Defines if the mode of the [TdStepsComponent].  Defaults to [StepMode.Vertical | "vertical"]
 * @param {?} mode
 * @return {?}
 */
set mode(mode: StepMode) {
    switch (mode) {
      case StepMode.Horizontal:
        this._mode = StepMode.Horizontal;
        break;
      default:
        this._mode = StepMode.Vertical;
    }
  }
/**
 * @return {?}
 */
get mode(): StepMode {
    return this._mode;
  }
/**
 * stepChange?: function
 * Method to be executed when [onStepChange] event is emitted.
 * Emits an [IStepChangeEvent] implemented object.
 */
onStepChange: EventEmitter<IStepChangeEvent> = new EventEmitter<IStepChangeEvent>();
/**
 * Executed after content is initialized, loops through any [TdStepComponent] children elements,
 * assigns them a number and subscribes as an observer to their [onActivated] event.
 * @return {?}
 */
ngAfterContentInit(): void {
    this._registerSteps();
  }
/**
 * Unsubscribes from [TdStepComponent] children elements when component is destroyed.
 * @return {?}
 */
ngOnDestroy(): void {
    this._deregisterSteps();
  }
/**
 * Returns 'true' if [mode] equals to [StepMode.Horizontal | 'horizontal'], else 'false'.
 * @return {?}
 */
isHorizontal(): boolean {
    return this._mode === StepMode.Horizontal;
  }
/**
 * Returns 'true' if [mode] equals to [StepMode.Vertical | 'vertical'], else 'false'.
 * @return {?}
 */
isVertical(): boolean {
    return this._mode === StepMode.Vertical;
  }
/**
 * @return {?}
 */
areStepsActive(): boolean {
    return this._steps.filter((step: TdStepComponent) => {
      return step.active;
    }).length > 0;
  }
/**
 * Wraps previous and new [TdStepComponent] numbers in an object that implements [IStepChangeEvent]
 * and emits [onStepChange] event.
 * @param {?} step
 * @return {?}
 */
private _onStepSelection(step: TdStepComponent): void {
    if (this.prevStep !== step) {
      let /** @type {?} */ prevStep: TdStepComponent = this.prevStep;
      this.prevStep = step;
      let /** @type {?} */ event: IStepChangeEvent = {
        newStep: step,
        prevStep: prevStep,
      };
      this._deactivateAllBut(step);
      this.onStepChange.emit(event);
    }
  }
/**
 * Loops through [TdStepComponent] children elements and deactivates them ignoring the one passed as an argument.
 * @param {?} activeStep
 * @return {?}
 */
private _deactivateAllBut(activeStep: TdStepComponent): void {
    this._steps.filter((step: TdStepComponent) => step !== activeStep)
    .forEach((step: TdStepComponent) => {
      step.active = false;
    });
  }
/**
 * @return {?}
 */
private _registerSteps(): void {
    this._subcriptions = [];
    this._steps.toArray().forEach((step: TdStepComponent) => {
      let /** @type {?} */ subscription: Subscription = step.onActivated.asObservable().subscribe(() => {
        this._onStepSelection(step);
      });
      this._subcriptions.push(subscription);
    });
  }
/**
 * @return {?}
 */
private _deregisterSteps(): void {
    if (this._subcriptions) {
      this._subcriptions.forEach((subs: Subscription) => {
        subs.unsubscribe();
      });
      this._subcriptions = undefined;
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  moduleId: module.id,
  selector: 'td-steps',
  styleUrls: ['./steps.component.css' ],
  templateUrl: './steps.component.html',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'stepsContent': [{ type: ContentChildren, args: [TdStepComponent, ] },],
'mode': [{ type: Input, args: ['mode', ] },],
'onStepChange': [{ type: Output, args: ['stepChange', ] },],
};
}

function TdStepsComponent_tsickle_Closure_declarations() {
/** @type {?} */
TdStepsComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TdStepsComponent.ctorParameters;
/** @type {?} */
TdStepsComponent.propDecorators;
/** @type {?} */
TdStepsComponent.prototype._subcriptions;
/** @type {?} */
TdStepsComponent.prototype._mode;
/** @type {?} */
TdStepsComponent.prototype._steps;
/** @type {?} */
TdStepsComponent.prototype.prevStep;
/**
 * stepChange?: function
 * Method to be executed when [onStepChange] event is emitted.
 * Emits an [IStepChangeEvent] implemented object.
 * @type {?}
 */
TdStepsComponent.prototype.onStepChange;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
